import { memo } from 'react';
import Icons from 'assets/icons/icons_sprite.svg';

type AppUseIconPropsType = {
  name: string;
  className?: string;
  color?: `#${string}` | 'currentColor';
  width?: string;
  height?: string;
  style?: React.CSSProperties;
};

const AppUseIcon = ({ name, color = '#414141', width = '21', height = '21', className = '', style = {} }: AppUseIconPropsType) => {
  return (
    <>
      <svg className={`icon ${className}`} width={width} viewBox={`0 0 ${width} ${height}`} fill={color} style={style}>
        <use xlinkHref={Icons + `#${name}`} href={Icons + `#${name}`} />
      </svg>
    </>
  );
};

export default memo(AppUseIcon);
